import { AiOutlineCloseCircle } from "react-icons/ai";
import Modal from "../../common/Modal";
import styled from "styled-components";
import removeTimezone from "../../../utils/removeTimezone";
import { useAdmin } from "../../../context/admin";
import AdminService from "../../../services/admin.service";
import Checkbox from "../../common/Checkbox";
import { useGlobal } from "../../../context/global";
import insert from "../../../utils/insert";
import { FaTrash } from "react-icons/fa6";
import { MdEdit } from "react-icons/md";

export default function ViewPaymentsReservation() {
    const { setMessage, setIsLoading } = useGlobal()
    const { viewPaymentsData, setViewPaymentsData, setIsCreatePaymentReservationModalOpen, setEditPaymentReservationData } = useAdmin()

    async function authorizePayment(id: string) {
        setIsLoading(true)
        try {
            const oldList = viewPaymentsData!;
            const payment = oldList.find(p => p.id === id)!
            payment.authorized = !payment.authorized
            const index = oldList.findIndex(p => p.id === id)
            setViewPaymentsData(insert(oldList.filter(p => p.id !== id), index, payment))
            const response = await AdminService.authorizeReservationPayment(id)
            setMessage({type: 'success', content: 'Payment authorization updated'})
        } catch (error) {
            console.log(error);
        }
        finally {
            setIsLoading(false)
            setTimeout(() => {
                setMessage(undefined)
            }, 3000);
        }
    }

    async function deletePayment(id: string) {
        setIsLoading(true)
        try {
            const response = await AdminService.deleteReservationPayment(id)
            setViewPaymentsData(viewPaymentsData!.filter(p => p.id !== id))
            setMessage({type: 'success', content: 'Payment deleted'})
        } catch (error) {
            console.log(error);
        }
        finally {
            setIsLoading(false)
            setTimeout(() => {
                setMessage(undefined)
            }, 3000);
        }
    }
    return (
        <Modal>
            <h1>View Payments</h1>
            <div className="actions"
            >
                <button
                type="button"
                onClick={() => setIsCreatePaymentReservationModalOpen(true)}
                style={{float: 'initial'}}
                >
                    Create
                </button>
            </div>
                <TableWrapper>
                        <Table>
                            <thead>
                                <th>Corresponde a</th>
                                <th>Amount</th>
                                <th>Amount tickets</th>
                                <th>Payment Date</th>
                                <th>Authorized</th>
                                <th>Pic</th>
                                <th>Remarks</th>
                                <th style={{ width: '40px'}}></th>
                                <th style={{ width: '40px'}}></th>
                            </thead>
                            <tbody>
                                {
                                    viewPaymentsData!.map(payment => {
                                            return <tr key={payment.id}>
                                                <td>
                                                    {payment.scope === 'group' && 'Todo el grupo'}
                                                    {payment.scope === 'reservation' && `${payment.passenger_name || ''} — ${payment.tour_id || ''}`}
                                                    {!payment.scope && '—'}
                                                </td>
                                                <td>{payment.amount || 0}</td>
                                                <td>{payment.amount_tickets || 0}</td>
                                                <td>{removeTimezone(payment.created_at.toString())}</td>
                                                <td>
                                                    <CheckboxWrapper>
                                                        <Checkbox
                                                        checked={payment.authorized || false}
                                                        onChange={() => authorizePayment(payment.id)}
                                                        />
                                                    </CheckboxWrapper>
                                                </td>
                                                <td>
                                                    {
                                                        !payment.pic ? 'No image' : 
                                                        <div className="img">
                                                            <img crossOrigin="anonymous" src={`${process.env.REACT_APP_API_URL}/files/${payment.pic}`} alt="" />
                                                            <a target="_BLANK" href={`${process.env.REACT_APP_API_URL}/files/${payment.pic}`}></a>
                                                        </div>
                                                    }
                                                </td>
                                                <td>{payment.remarks}</td>
                                                <td>
                                                    <button
                                                    type="button"
                                                    className="delete"
                                                    onClick={() => deletePayment(payment.id)}
                                                    >
                                                        <FaTrash
                                                        />
                                                    </button>
                                                </td>
                                                <td>
                                                    <button
                                                    type="button"
                                                    onClick={() => setEditPaymentReservationData(payment)}
                                                    >
                                                        <MdEdit/>
                                                    </button>
                                                </td>
                                            </tr>
                                    })
                                }
                                </tbody>
                        </Table>
                </TableWrapper>
            <div className="close"
            onClick={() => setViewPaymentsData(undefined)}
            >
                <AiOutlineCloseCircle/>
            </div>
        </Modal>
    )
}

const TableWrapper = styled.div`
width: 100%;
height: 100%;
overflow: hidden;
overflow-x: unset;
`

const Table = styled.table`
border-collapse: collapse;
table-layout: fixed;
height: 100%;
position: relative;
width: 100%;
min-width: 400px;
overflow: hidden;
thead {
    width: 100%;
    background-color: #FFFFFF;
}
th {
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
}
td {
    text-align: center;
    height: 100px;
    button {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: auto;
        width: 25px;
        height: 25px;
        border-radius: 5px;
        border: none;
        background-color: ${props => props.theme.blueLight};
        color: ${props => props.theme.white};
        cursor: pointer;
    }
    button.delete {
        background-color: ${props => props.theme.lightRed};

    }
    .img {
        width: 100%;
        position: relative;
        img {
            width: 100%;
        }
        a {
            width: 100%;
            height: 100%;
            display: block;
            position: absolute;
            z-index: 10;
            top: 0;
            left: 0;
        }
        padding: 10px;
    }
}
tr {
    height: 40px;
    width: 100%;
}
`

const CheckboxWrapper = styled.div`
cursor: pointer;
display: flex;
align-items: center;
justify-content: center;
`